import { Box, Button, Center, Flex, IconButton, Text } from "@chakra-ui/react";
import { FaPaperclip } from "react-icons/fa";
import { RefObject } from "react";
import { PDFIcon } from "components/vectors/pdf-icon";
import { CSVIcon } from "components/vectors/csv-icon";
import { ExelIcon } from "components/vectors/file-extensions-icons";
import {
  BINIcon,
  GenericFileIcon,
  JSONFileIcon,
} from "components/vectors/bin-icon";
import { SendIcon2 } from "components/vectors/send-icon";
import { CloseIcon } from "@chakra-ui/icons";
import { UseWebSocketProps } from "components/atendimentos-components/use-init-web-socket/types";
import { WhatsAppMessagesHelper } from "../hooks/use-whats-app-session-controls/ws-messages-api";
import {
  ButtonWithLoading,
  IconButtonWithLoading,
} from "components/mailing-components/mailing-table/icon-button-with-loading";
import { TextFileIcon } from "components/vectors/text-file-icon";

interface AnexarDocumentProps {
  isUsingAudio?: boolean;
  fileInputRef: RefObject<HTMLInputElement>;
  isDisabled?: boolean;
  whatsAppButtonStyles?: any;
  setSelectedFile: (file: File | undefined) => void;
  selectedFile?: File;
  fileExtensions?: string[];
  wsSession: UseWebSocketProps;
}

export function AnexarDocument({
  isUsingAudio = false,
  fileInputRef,
  isDisabled = false,
  whatsAppButtonStyles,
  setSelectedFile,
  fileExtensions,
  selectedFile,
  wsSession,
}: AnexarDocumentProps) {
  const whatsAppApi = new WhatsAppMessagesHelper(wsSession);
  return (
    <>
      <IconButton
        mt="auto"
        icon={<FaPaperclip />}
        animation={isUsingAudio ? "recording 1.6s linear infinite" : ""}
        aria-label="Anexar arquivo"
        onClick={() => {
          fileInputRef.current?.click();
        }}
        isDisabled={isDisabled}
        {...whatsAppButtonStyles}
      />
      <input
        key={Math.random()}
        ref={fileInputRef}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => {
          const file = e.target.files?.[0];
          setSelectedFile(file);
        }}
        accept={fileExtensions?.join(",")}
      />
      {selectedFile && (
        <Center
          pos="absolute"
          inset="0"
          zIndex={100}
          bg="rgba(0,0,0,0.5)"
          flexDir="column"
          p="15px"
          onClick={() => {
            setSelectedFile(undefined);
          }}
          backdropFilter="blur(5px)"
        >
          <Box
            bg="whiteAlpha.800"
            p="20px"
            borderRadius="8px"
            boxShadow="lg"
            textAlign="center"
            onClick={(e) => e.stopPropagation()}
            minW="220px"
            // backdropFilter="blur(5px)"
          >
            <Flex justifyContent="flex-end">
              <IconButton
                variant="ghost"
                icon={<CloseIcon />}
                _hover={{ bg: "rgba(0,0,0,0.1)" }}
                aria-label="Cancelar envio"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedFile(undefined);
                }}
                transform="translate(8px, -8px)"
              />
            </Flex>
            <Center w="100%" mb="10px">
              {selectedFile.type === "application/pdf" ? (
                <PDFIcon height="40px" width="40px" />
              ) : selectedFile.type === "text/csv" ? (
                <CSVIcon height="40px" width="40px" />
              ) : selectedFile.type ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ? (
                <ExelIcon height="40px" width="40px" />
              ) : selectedFile.type === "text/plain" ? (
                <TextFileIcon height="40px" width="40px" />
              ) : selectedFile.type === "application/json" ? (
                <JSONFileIcon height="40px" width="40px" />
              ) : (
                <GenericFileIcon height="40px" width="40px" />
              )}
            </Center>
            <Text
              fontSize="14px"
              fontWeight="medium"
              whiteSpace="pre-wrap"
              wordBreak="break-word"
            >
              {selectedFile.name}
            </Text>
            <Text fontSize="12px" color="gray.500">
              {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
            </Text>
            <Flex mt="10px" gap="10px" justifyContent="center">
              <IconButtonWithLoading
                tooltipMessage="Enviar arquivo"
                icon={<SendIcon2 />}
                animation={isUsingAudio ? "recording 1.6s linear infinite" : ""}
                aria-label="Enviar arquivo"
                onClick={async (e) => {
                  e.stopPropagation();

                  if (selectedFile) {
                    const extension = selectedFile.name
                      .split(".")
                      .pop()
                      ?.toLowerCase();
                    if (
                      extension &&
                      [
                        "jpg",
                        "jpeg",
                        "png",
                        "gif",
                        "bmp",
                        "webp",
                        "tiff",
                        "tif",
                        "pjpeg",
                        "svg",
                      ].includes(extension)
                    ) {
                      await whatsAppApi.sendImage(selectedFile);
                    } else if (
                      extension &&
                      ["mp4", "mov", "m4v", "3gp"].includes(extension)
                    ) {
                      await whatsAppApi.sendVideo(selectedFile);
                    } else {
                      await whatsAppApi.sendDocument(selectedFile);
                    }
                    setSelectedFile(undefined);
                  }
                }}
                isDisabled={isDisabled}
                {...whatsAppButtonStyles}
                w="auto"
                fontSize="13px"
              ></IconButtonWithLoading>
            </Flex>
          </Box>
        </Center>
      )}
    </>
  );
}
